import { render, staticRenderFns } from "./AddMaintenance.vue?vue&type=template&id=2fa5c5c9&scoped=true"
import script from "./AddMaintenance.vue?vue&type=script&lang=js"
export * from "./AddMaintenance.vue?vue&type=script&lang=js"
import style0 from "./AddMaintenance.vue?vue&type=style&index=0&id=2fa5c5c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa5c5c9",
  null
  
)

export default component.exports